module.exports = __webpack_public_path__ + "static/media/coin.38789e25.png";